import { useEffect, useState } from 'react';

import { applyTheme, readStoredTheme, toggleTheme, type Theme } from '../lib/theme';

const ICON_STROKE = {
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.7,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
};

/**
 * Light/dark toggle. The state is a `data-theme` attribute on `<html>`, which
 * is the only thing `theme.css` needs to re-map the token values; the choice is
 * persisted in `localStorage`.
 */
export function ThemeToggle() {
  const [theme, setTheme] = useState<Theme>(readStoredTheme);

  useEffect(() => {
    applyTheme(theme);
  }, [theme]);

  const dark = theme === 'dark';

  return (
    <button
      type="button"
      className="icon-btn"
      onClick={() => setTheme((current) => toggleTheme(current))}
      aria-label={dark ? 'Switch to light theme' : 'Switch to dark theme'}
      aria-pressed={dark}
      data-testid="theme-toggle"
    >
      {dark ? (
        <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
          <circle cx="12" cy="12" r="4" {...ICON_STROKE} />
          <path d="M12 3v2m0 14v2M3 12h2m14 0h2M5.6 5.6 7 7m10 10 1.4 1.4M5.6 18.4 7 17M17 7l1.4-1.4" {...ICON_STROKE} />
        </svg>
      ) : (
        <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
          <path d="M20 14.5A8.5 8.5 0 0 1 9.5 4a8.5 8.5 0 1 0 10.5 10.5Z" {...ICON_STROKE} />
        </svg>
      )}
    </button>
  );
}
